import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import "../asset/style/Search.css";
import { useProjectMethods, useProjectVariables } from '../context/ProjectContext';

function Search(){    
    const {keyword, in_content}= useProjectVariables();
    const [pageQuery, setPageQuery] = useSearchParams();
    const navigate= useNavigate();
    const inputNode= useRef();
    const filterNode = useRef();
    const {setKeyword, setIn_content}= useProjectMethods()

    useEffect(()=>{
        if (keyword === "" && pageQuery.get("search")) navigate("/portfolio");
    });

    const handleSearch= (e)=>{
        e.preventDefault();
        if (keyword === inputNode.current.value && in_content === filterNode.current.checked) return;
        setPageQuery({ search: true });
        setIn_content(filterNode.current.checked);
        setKeyword(inputNode.current.value);
    }
    

    return(
        <div className="search">
            <input type="text" ref={inputNode} />
            <div className='filter'><input type='checkbox' ref={filterNode} /><span>Search through  project content</span></div>
            <button onClick={handleSearch} className="button">Search</button>
        </div>
    );
}

export default Search;